import { Button, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';

import { MainLayout } from 'components/layouts';
import { routes } from 'config/routes';
import { useLocalStore } from 'hooks/';
import { FormListPageStore } from 'stores/local';

import s from './FormListPage.module.scss';
import { FormListTable, NoContentStub } from './components';
import { NotificationDrawer } from './components/NotificationDrawer';

const FormListPage: React.FC = () => {
  const { t } = useTranslation();
  const store = useLocalStore(() => new FormListPageStore());
  const [searchParams, setSearchParams] = useSearchParams();

  const notificationFormId = searchParams.get('notification');
  const notificationTab = searchParams.get('tab') || 'send';
  const drawerOpened = !!notificationFormId;

  const handleDrawerClose = React.useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  const handleTabChange = React.useCallback(
    (tab: string) => {
      setSearchParams({ notification: notificationFormId!, tab });
    },
    [notificationFormId, setSearchParams]
  );

  React.useEffect(() => {
    store.fetchData();
  }, [store, store.fetchData]);

  return (
    <MainLayout>
      <div className={s.page}>
        <header className={s.page__header}>
          <Typography.Title level={3}>{t('formList.title')}</Typography.Title>
          <Button type="primary">
            <Link to={routes.form.initForm.createPath()}>
              {t('formList.createForm')}
            </Link>
          </Button>
        </header>
        <div className={s.page__content}>
          {store.formListSuccess && store.formList.length === 0 ? (
            <NoContentStub />
          ) : (
            <FormListTable store={store} />
          )}
        </div>
      </div>
      {drawerOpened && (
        <NotificationDrawer
          opened={drawerOpened}
          onClose={handleDrawerClose}
          formId={Number(notificationFormId)}
          store={store}
          activeTab={notificationTab}
          onTabChange={handleTabChange}
        />
      )}
    </MainLayout>
  );
};

export default observer(FormListPage);
